import { Box, ButtonBase, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PropTypes from 'prop-types';
import {
  cardShadow, cardShadowHover, cardShadowOnWhite, helpColors, helpEase,
} from '../style/helpStyles';

const CategoryCard = ({
  title, Icon, selected, isMobile, onClick,
}) => (
  <ButtonBase
    onClick={onClick}
    aria-pressed={selected}
    sx={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      textAlign: 'left',
      justifyContent: 'flex-start',
      backgroundColor: helpColors.white,
      border: `1px solid ${selected ? helpColors.pink : helpColors.line}`,
      borderRadius: '22px',
      padding: '18px',
      // En desktop la sección tiene fondo blanco, así que la card necesita algo más de sombra.
      boxShadow: selected ? cardShadowHover : (isMobile ? cardShadow : cardShadowOnWhite),
      transition: `transform .35s ${helpEase}, box-shadow .35s ${helpEase}, border-color .35s ${helpEase}`,
      '&:hover': {
        transform: 'translateY(-3px)',
        borderColor: 'transparent',
        boxShadow: cardShadowHover,
      },
      '&:hover .help-cat-icon': {
        transform: 'rotate(-6deg) scale(1.06)',
        backgroundColor: helpColors.pink,
        color: helpColors.white,
      },
    }}
  >
    <Box
      className="help-cat-icon"
      sx={{
        width: 54,
        height: 54,
        flexShrink: 0,
        borderRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: selected ? helpColors.pink : helpColors.pink50,
        color: selected ? helpColors.white : helpColors.pink,
        transition: `transform .35s ${helpEase}, background-color .35s ${helpEase}, color .35s ${helpEase}`,
      }}
    >
      <Icon sx={{ fontSize: 28 }} />
    </Box>
    <Typography
      component="h3"
      sx={{
        flex: 1,
        fontWeight: 600,
        fontSize: 16,
        lineHeight: 1.25,
        letterSpacing: '-0.01em',
        color: selected ? helpColors.pink : helpColors.ink,
      }}
    >
      {title}
    </Typography>
    <ChevronRightIcon sx={{ color: helpColors.pink, fontSize: 22 }} />
  </ButtonBase>
);

CategoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  selected: PropTypes.bool,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

CategoryCard.defaultProps = {
  selected: false,
  isMobile: false,
};

export default CategoryCard;
